module.exports = __webpack_public_path__ + "img/caratula_hoy_estamos_aqui.30c73ea1.jpg";